// extracted by mini-css-extract-plugin
export default {"Container":"RestrictionsSection_Container__x+Fsz","RestrictionLabel":"RestrictionsSection_RestrictionLabel__9lrMk"};